// extracted by mini-css-extract-plugin
export default {"bgVideoWrapper":"NorthernLights_bgVideoWrapper__oyqLc"};